export const groupFeatureKey = 'group';

export type GroupModel = {
  id: number;
  name: string;
};
